import apiClient from './client';

export type AppPlatform = 'ios' | 'android';

export interface LocalizedMessage {
  uz?: string;
  ru?: string;
  kiril?: string;
}

export interface AppConfig {
  id: string;
  platform: AppPlatform;
  latest_version: string;
  min_required_version: string;
  store_url: string;
  force_update_message: LocalizedMessage;
  soft_update_message: LocalizedMessage;
  maintenance_title: LocalizedMessage;
  maintenance_message: LocalizedMessage;
  maintenance_mode: boolean;
  /** Кнопка «Войти через Telegram» на экране входа (ADR 0009, Фаза 2) */
  telegram_login_enabled: boolean;
  created_at: string;
  updated_at: string;
}

export type UpdateAppConfigPayload = Partial<
  Omit<AppConfig, 'id' | 'platform' | 'created_at' | 'updated_at'>
>;

export const appConfigApi = {
  async list(): Promise<AppConfig[]> {
    const response = await apiClient.get<AppConfig[]>('/admin/app-config');
    return response.data;
  },

  async update(platform: AppPlatform, payload: UpdateAppConfigPayload): Promise<AppConfig> {
    const response = await apiClient.patch<AppConfig>(
      `/admin/app-config/${platform}`,
      payload,
    );
    return response.data;
  },
};
